export interface DownloadConfig {
  downloadType: DownloadType;
}

export enum DownloadType {
  CurrentPage = 'CURRENT_PAGE',
  AllResults = 'ALL_RESULTS'
}
export enum ReportType {
  PRODUCTS_DOWNLOAD = 'PRODUCTS_DOWNLOAD',
  DOSSIERS_DOWNLOAD = 'DOSSIERS_DOWNLOAD'
}
